// extracted by mini-css-extract-plugin
export var carrierIcon = "_yb-0";
export var carrierLogo = "_yb-1";
export var detailsSection = "_yb-2";